// helpers/helpers.js

export function getNumberFromAngle(angle, colorsCount) {
  return Math.floor((360 - angle % 360 + 360) % 360 / 360 * colorsCount);
}

// 贝塞尔缓动函数
export function bezierEasing(mX1, mY1, mX2, mY2) {
  // 简化版贝塞尔缓动
  return function(t) {
    return t * t * (3 - 2 * t); // ease-in-out 近似
  };
}

// 倒计时函数
export function countdown(startAt, options = {}) {
  const { timeShift = 0, tickInterval = 16, skipDuration = true } = options;
  
  return new Observable((observer) => {
    const startTime = new Date(startAt).getTime() + timeShift;
    
    const interval = setInterval(() => {
      const now = Date.now();
      const secondsLeft = Math.max((startTime - now) / 1000, 0);
      
      observer.next({
        secondsLeft,
        isFinished: secondsLeft <= 0
      });
      
      if (secondsLeft <= 0) {
        clearInterval(interval);
        observer.complete();
      }
    }, tickInterval);
    
    return () => clearInterval(interval);
  });
}

// Observable 辅助类（简化版）
export class Observable {
  constructor(subscribe) {
    this._subscribe = subscribe;
  }
  
  subscribe(observer) {
    return this._subscribe(observer);
  }
  
  pipe(...operators) {
    let result = this;
    for (const operator of operators) {
      result = operator(result);
    }
    return result;
  }
}

export function takeUntil(destroy$) {
  return (source) => {
    return new Observable((observer) => {
      const subscription = source.subscribe(observer);
      const destroySub = destroy$.subscribe(() => {
        subscription.unsubscribe();
        destroySub.unsubscribe();
      });
      return () => {
        subscription.unsubscribe();
        destroySub.unsubscribe();
      };
    });
  };
}

export function distinctUntilChanged() {
  return (source) => {
    return new Observable((observer) => {
      let lastValue;
      return source.subscribe({
        next(value) {
          if (value !== lastValue) {
            lastValue = value;
            observer.next(value);
          }
        },
        error(err) { observer.error(err); },
        complete() { observer.complete(); }
      });
    });
  };
}

export function map(fn) {
  return (source) => {
    return new Observable((observer) => {
      return source.subscribe({
        next(value) { observer.next(fn(value)); },
        error(err) { observer.error(err); },
        complete() { observer.complete(); }
      });
    });
  };
}

export function interval(ms) {
  return new Observable((observer) => {
    let count = 0;
    const interval = setInterval(() => {
      observer.next(count++);
    }, ms);
    return () => clearInterval(interval);
  });
}